import * as React from 'react';

import config from 'js/app/config';
import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Link } from '@coursera/cds-core';

import type { NotificationConfig } from 'bundles/ai-coach-platform/components/patterns/chat/notifications/types';
import { ResolutionStatus } from 'bundles/ai-coach-platform/components/patterns/suggestions/types';
import localStorageEx from 'bundles/common/utils/localStorageEx';

import _t from 'i18n!nls/ai-coach-platform';

export const COACH_CHAT_PRIVACY_NOTIFICATION_DISMISSED = 'AiCoachPlatform_PrivacyDisclosureNotificationDismissed';

export const isPrivacyNotificationDismissed = (): boolean | null => {
  return localStorageEx.getItem<boolean>(COACH_CHAT_PRIVACY_NOTIFICATION_DISMISSED, (value) => value === 'true', false);
};

const setPrivacyNotificationDismissed = () => {
  localStorageEx.setItem(COACH_CHAT_PRIVACY_NOTIFICATION_DISMISSED, true, () => 'true');
};

const getPrivacyNoticeLink = () => {
  return `${config.url.base}about/privacy`;
};

export const getPrivacyNotificationConfig = (): NotificationConfig => ({
  id: 'privacy-disclosure-notification',
  status: ResolutionStatus.UNRESOLVED,
  title: _t('Your privacy and this chat'),
  content: (
    <FormattedMessage
      message={_t(
        'Your chat history may be temporarily saved to personalize your experience. If you log in or create an account, it may be linked to your account activity [see {privacyNoticeLink}]'
      )}
      privacyNoticeLink={
        <Link href={getPrivacyNoticeLink()} target="_blank" rel="noopener">
          {_t('Privacy Notice')}
        </Link>
      }
    />
  ),
  acceptLabel: _t('Got it'),
  hideDismiss: true,
  onAction: setPrivacyNotificationDismissed,
  onMount: () => {},
  isDismissed: isPrivacyNotificationDismissed() ?? false,
});
